import React from "react";
import "./FacilitySlider.css";
import guidence24X7 from "../images/24x7 Guidence.jpg";
import jobtraining from "../images/Job-oriented training.jpg";
import liveprojectwork from "../images/LIVE PROJECT WORK.jpg";

import indestry from "../images/Industry-experienced trainers.jpg";
import  certification from "../images/Certification after course completion.jpg";


function FacilitySlider() {
  return (
    <div className="slider">
      <div className="slidenew-track">
        <div className="slidenew">
          <img src={guidence24X7} alt="guidence24X7" />
        </div>
        <div className="slidenew">
          <img src={jobtraining} alt="jobtraining" />
        </div>
        <div className="slidenew">
          <img src={liveprojectwork} alt="carrier" />
        </div>

        {/* Duplicate logos for smooth infinite effect */}
        <div className="slidenew">
            <img src={indestry} alt="indestry" />
        </div>
        <div className="slidenew">
            <img src={certification} alt="certification" />
        </div>
        <div className="slidenew">
                 <img src={guidence24X7} alt="guidence24X7" />
        </div>
      </div>
    </div>
  );
}

export default FacilitySlider;
